import { useUpdateNotificationInAppMutation } from '../../../api/mutations/__generated__/updateNotificationInApp.gql'
import { NotificationInAppContent, NotificationInAppUpdateIsRead } from '../../../utilities/notifications/_types'
import { useCreateNotificationInAppStore } from '../../../utilities/notifications/_store'
import {
    FetchNotificationInAppQuery,
    useFetchNotificationInAppLazyQuery,
} from '../../../api/queries/__generated__/notificationInApp.gql'

export { useCreateNotificationInAppStore }

export const useInitNotificationInAppStore = () => {
    const { dispatch } = useCreateNotificationInAppStore()
    const [query] = useFetchNotificationInAppLazyQuery()
    const initNotificationInAppStore = async (userId: string, source: string) => {
        const { data, loading } = await query({
            variables: {
                userId,
                source,
            },
        })
        if (!loading && data) {
            dispatch({
                type: 'SET_NOTIFICATION',
                notifications: formatNotificationData(data).data,
                source,
            })
        }
    }
    return { initNotificationInAppStore }
}

export const useUpdateNotificationInApp = () => {
    const { notifications } = useCreateNotificationInAppStore()
    const [updateNotificationInAppMutation] = useUpdateNotificationInAppMutation()

    const updateNotificationInApp = (source) => {
        if (notifications[source]?.data.length > 0) {
            const _notificationToUpdate: Array<NotificationInAppUpdateIsRead> = []

            notifications[source].data.forEach((value) => {
                if (value) {
                    _notificationToUpdate.push({
                        input: {
                            id: value.objectId,
                            fields: {
                                isRead: true,
                            },
                        },
                    })
                }
            })

            for (const notif of _notificationToUpdate) {
                updateNotificationInAppMutation({
                    variables: notif,
                })
            }
        }
    }
    return { updateNotificationInApp }
}

const formatNotificationData = (data: FetchNotificationInAppQuery) => {
    const notifications = data?.notificationInApps?.edges
    let _data: Array<NotificationInAppContent | null> = []
    if (notifications && notifications.length > 0) {
        _data = notifications.map((notification) => {
            if (!notification || !notification.node) return null
            const _notification: NotificationInAppContent = {
                content: notification.node.content,
                id: notification.node.id,
                objectId: notification.node.objectId,
                createdAt: notification.node.createdAt,
                updatedAt: notification.node.updatedAt || null,
                source: notification.node.source,
                isRead: notification.node.isRead,
            }
            return _notification
        })
    }
    return {
        data: _data,
        allowDisplay: _data.length > 0,
        error: null,
        refetch: null,
    }
}
